module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_3.9c2cfff6.png";